interface CreateMarkProps {
  text: string
  color: string
  dataType: string
}

export const createMark = ({ text, color, dataType }: CreateMarkProps) => {
  return `<mark class="slash-command-pill" data-type="${dataType}" style="background-color: ${color};color: rgb(30, 30, 30);">${text}</mark> `
}
